import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grin-stars': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456zM353.6 304.6C327.7 312.9 289.2 317.7 248 317.7S168.4 312.9 142.4 304.6C132.6 301.5 123 309.9 124.7 319.9 132.6 367.1 196 399.9 248 399.9S363.3 367 371.3 319.9C372.9 310.1 363.6 301.5 353.6 304.6zM125.7 247.1C124.7 253.3 131.1 258.1 136.7 255L168 238.7 199.3 255C204.9 258.1 211.3 253.3 210.3 247.1L204.3 212.2 229.7 187.6C234.2 183.1 231.6 175.4 225.4 174.4L190.5 169.4 175 137.8C172.1 132 164 132 161.1 137.8L145.6 169.4 110.7 174.4C104.5 175.3 101.8 183 106.4 187.6L131.8 212.2 125.7 247.1zM385.4 174.4L350.5 169.4 335 137.8C332.1 132 324 132 321.1 137.8L305.6 169.4 270.7 174.4C264.5 175.3 261.8 183 266.4 187.6L291.8 212.2 285.8 247.1C284.8 253.3 291.2 258.1 296.8 255L328.1 238.7 359.4 255C365 258.1 371.4 253.3 370.4 247.1L364.4 212.2 389.8 187.6C394.3 183 391.6 175.4 385.4 174.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/grin-stars.js
// module id = zcUJ
// module chunks = 144